export default __webpack_public_path__ + "static/media/acceso_perfiles_ilus5.f9255478.svg";